export const ColorPalette = {
	// Blue
	blue: 'var(--epods--color-blue-a-700)',
	blue50: 'var(--epods--color-blue-50)',
	blue100: 'var(--epods--color-blue-100)',
	blue200: 'var(--epods--color-blue-200)',
	blue300: 'var(--epods--color-blue-300)',
	blue400: 'var(--epods--color-blue-400)',
	blue500: 'var(--epods--color-blue-500)',
	blue600: 'var(--epods--color-blue-600)',
	blue700: 'var(--epods--color-blue-700)',
	blue800: 'var(--epods--color-blue-800)',
	blue900: 'var(--epods--color-blue-900)',
	blueA100: 'var(--epods--color-blue-a-100)',
	blueA200: 'var(--epods--color-blue-a-200)',
	blueA400: 'var(--epods--color-blue-a-400)',
	blueA700: 'var(--epods--color-blue-a-700)',

	// Blue Grey
	blueGrey: 'var(--epods--color-bluegrey-500)',
	blueGrey50: 'var(--epods--color-bluegrey-50)',
	blueGrey100: 'var(--epods--color-bluegrey-100)',
	blueGrey200: 'var(--epods--color-bluegrey-200)',
	blueGrey300: 'var(--epods--color-bluegrey-300)',
	blueGrey400: 'var(--epods--color-bluegrey-400)',
	blueGrey500: 'var(--epods--color-bluegrey-500)',
	blueGrey600: 'var(--epods--color-bluegrey-600)',
	blueGrey700: 'var(--epods--color-bluegrey-700)',
	blueGrey800: 'var(--epods--color-bluegrey-800)',
	blueGrey900: 'var(--epods--color-bluegrey-900)',
	blueGreyA100: 'var(--epods--color-bluegrey-a-100)',
	blueGreyA200: 'var(--epods--color-bluegrey-a-200)',
	blueGreyA400: 'var(--epods--color-bluegrey-a-400)',
	blueGreyA700: 'var(--epods--color-bluegrey-a-700)',

	// Deep Orange
	deepOrange: 'var(--epods--color-deeporange)',
	deepOrange50: 'var(--epods--color-deeporange-50)',
	deepOrange100: 'var(--epods--color-deeporange-100)',
	deepOrange200: 'var(--epods--color-deeporange-200)',
	deepOrange300: 'var(--epods--color-deeporange-300)',
	deepOrange400: 'var(--epods--color-deeporange-400)',
	deepOrange500: 'var(--epods--color-deeporange-500)',
	deepOrange600: 'var(--epods--color-deeporange-600)',
	deepOrange700: 'var(--epods--color-deeporange-700)',
	deepOrange800: 'var(--epods--color-deeporange-800)',
	deepOrange900: 'var(--epods--color-deeporange-900)',
	deepOrangeA100: 'var(--epods--color-deeporange-a-100)',
	deepOrangeA200: 'var(--epods--color-deeporange-a-200)',
	deepOrangeA400: 'var(--epods--color-deeporange-a-400)',
	deepOrangeA700: 'var(--epods--color-deeporange-a-700)',

	// Amber
	amber: 'var(--epods--color-amber)',
	amber50: 'var(--epods--color-amber-50)',
	amber100: 'var(--epods--color-amber-100)',
	amber200: 'var(--epods--color-amber-200)',
	amber300: 'var(--epods--color-amber-300)',
	amber400: 'var(--epods--color-amber-400)',
	amber500: 'var(--epods--color-amber-500)',
	amber600: 'var(--epods--color-amber-600)',
	amber700: 'var(--epods--color-amber-700)',
	amber800: 'var(--epods--color-amber-800)',
	amber900: 'var(--epods--color-amber-900)',
	amberA100: 'var(--epods--color-amber-a-100)',
	amberA200: 'var(--epods--color-amber-a-200)',
	amberA400: 'var(--epods--color-amber-a-400)',
	amberA700: 'var(--epods--color-amber-a-700)',

	// Light Green
	lightGreen: 'var(--epods--color-lightgreen)',
	lightGreen50: 'var(--epods--color-lightgreen-50)',
	lightGreen100: 'var(--epods--color-lightgreen-100)',
	lightGreen200: 'var(--epods--color-lightgreen-200)',
	lightGreen300: 'var(--epods--color-lightgreen-300)',
	lightGreen400: 'var(--epods--color-lightgreen-400)',
	lightGreen500: 'var(--epods--color-lightgreen-500)',
	lightGreen600: 'var(--epods--color-lightgreen-600)',
	lightGreen700: 'var(--epods--color-lightgreen-700)',
	lightGreen800: 'var(--epods--color-lightgreen-800)',
	lightGreen900: 'var(--epods--color-lightgreen-900)',
	lightGreenA100: 'var(--epods--color-lightgreen-a-100)',
	lightGreenA200: 'var(--epods--color-lightgreen-a-200)',
	lightGreenA400: 'var(--epods--color-lightgreen-a-400)',
	lightGreenA700: 'var(--epods--color-lightgreen-a-700)',

	// greychrome Palette
	white: 'var(--epods--color-grey-0)',
	grey50: 'var(--epods--color-grey-50)',
	grey100: 'var(--epods--color-grey-100)',
	grey200: 'var(--epods--color-grey-200)',
	grey300: 'var(--epods--color-grey-300)',
	grey400: 'var(--epods--color-grey-400)',
	grey500: 'var(--epods--color-grey-500)',
	grey600: 'var(--epods--color-grey-600)',
	grey700: 'var(--epods--color-grey-700)',
	grey800: 'var(--epods--color-grey-800)',
	grey900: 'var(--epods--color-grey-900)',
	grey950: 'var(--epods--color-grey-950)',
	grey1000: 'var(--epods--color-grey-1000)',
	black: 'var(--epods--color-grey-1000)',

	//Red
	red50: 'var(--epods--color-red-50)',
	red100: 'var(--epods--color-red-100)',
	red200: 'var(--epods--color-red-200)',
	red300: 'var(--epods--color-red-300)',
	red400: 'var(--epods--color-red-400)',
	red500: 'var(--epods--color-red-500)',
	red600: 'var(--epods--color-red-600)',
	red700: 'var(--epods--color-red-700)',
	red800: 'var(--epods--color-red-800)',
	red900: 'var(--epods--color-red-900)',
	redA100: 'var(--epods--color-red-a-100)',
	redA200: 'var(--epods--color-red-a-200)',
	redA400: 'var(--epods--color-red-a-400)',
	redA700: 'var(--epods--color-red-a-700)',

	//Pink
	pink50: 'var(--epods--color-pink-50)',
	pink100: 'var(--epods--color-pink-100)',
	pink200: 'var(--epods--color-pink-200)',
	pink300: 'var(--epods--color-pink-300)',
	pink400: 'var(--epods--color-pink-400)',
	pink500: 'var(--epods--color-pink-500)',
	pink600: 'var(--epods--color-pink-600)',
	pink700: 'var(--epods--color-pink-700)',
	pink800: 'var(--epods--color-pink-800)',
	pink900: 'var(--epods--color-pink-900)',
	pinkA100: 'var(--epods--color-pink-a-100)',
	pinkA200: 'var(--epods--color-pink-a-200)',
	pinkA400: 'var(--epods--color-pink-a-400)',
	pinkA700: 'var(--epods--color-pink-a-700)',

	//Purple
	purple50: 'var(--epods--color-purple-50)',
	purple100: 'var(--epods--color-purple-100)',
	purple200: 'var(--epods--color-purple-200)',
	purple300: 'var(--epods--color-purple-300)',
	purple400: 'var(--epods--color-purple-400)',
	purple500: 'var(--epods--color-purple-500)',
	purple600: 'var(--epods--color-purple-600)',
	purple700: 'var(--epods--color-purple-700)',
	purple800: 'var(--epods--color-purple-800)',
	purple900: 'var(--epods--color-purple-900)',
	purpleA100: 'var(--epods--color-purple-a-100)',
	purpleA200: 'var(--epods--color-purple-a-200)',
	purpleA400: 'var(--epods--color-purple-a-400)',
	purpleA700: 'var(--epods--color-purple-a-700)',

	//DeepPurple
	deeppurple50: 'var(--epods--color-deeppurple-50)',
	deeppurple100: 'var(--epods--color-deeppurple-100)',
	deeppurple200: 'var(--epods--color-deeppurple-200)',
	deeppurple300: 'var(--epods--color-deeppurple-300)',
	deeppurple400: 'var(--epods--color-deeppurple-400)',
	deeppurple500: 'var(--epods--color-deeppurple-500)',
	deeppurple600: 'var(--epods--color-deeppurple-600)',
	deeppurple700: 'var(--epods--color-deeppurple-700)',
	deeppurple800: 'var(--epods--color-deeppurple-800)',
	deeppurple900: 'var(--epods--color-deeppurple-900)',
	deeppurpleA100: 'var(--epods--color-deeppurple-a-100)',
	deeppurpleA200: 'var(--epods--color-deeppurple-a-200)',
	deeppurpleA400: 'var(--epods--color-deeppurple-a-400)',
	deeppurpleA700: 'var(--epods--color-deeppurple-a-700)',

	//Indigo
	indigo50: 'var(--epods--color-indigo-50)',
	indigo100: 'var(--epods--color-indigo-100)',
	indigo200: 'var(--epods--color-indigo-200)',
	indigo300: 'var(--epods--color-indigo-300)',
	indigo400: 'var(--epods--color-indigo-400)',
	indigo500: 'var(--epods--color-indigo-500)',
	indigo600: 'var(--epods--color-indigo-600)',
	indigo700: 'var(--epods--color-indigo-700)',
	indigo800: 'var(--epods--color-indigo-800)',
	indigo900: 'var(--epods--color-indigo-900)',
	indigoA100: 'var(--epods--color-indigo-a-100)',
	indigoA200: 'var(--epods--color-indigo-a-200)',
	indigoA400: 'var(--epods--color-indigo-a-400)',
	indigoA700: 'var(--epods--color-indigo-a-700)',

	//Lightblue
	lightblue50: 'var(--epods--color-lightblue-50)',
	lightblue100: 'var(--epods--color-lightblue-100)',
	lightblue200: 'var(--epods--color-lightblue-200)',
	lightblue300: 'var(--epods--color-lightblue-300)',
	lightblue400: 'var(--epods--color-lightblue-400)',
	lightblue500: 'var(--epods--color-lightblue-500)',
	lightblue600: 'var(--epods--color-lightblue-600)',
	lightblue700: 'var(--epods--color-lightblue-700)',
	lightblue800: 'var(--epods--color-lightblue-800)',
	lightblue900: 'var(--epods--color-lightblue-900)',
	lightblueA100: 'var(--epods--color-lightblue-a-100)',
	lightblueA200: 'var(--epods--color-lightblue-a-200)',
	lightblueA400: 'var(--epods--color-lightblue-a-400)',
	lightblueA700: 'var(--epods--color-lightblue-a-700)',

	//Cyan
	cyan50: 'var(--epods--color-cyan-50)',
	cyan100: 'var(--epods--color-cyan-100)',
	cyan200: 'var(--epods--color-cyan-200)',
	cyan300: 'var(--epods--color-cyan-300)',
	cyan400: 'var(--epods--color-cyan-400)',
	cyan500: 'var(--epods--color-cyan-500)',
	cyan600: 'var(--epods--color-cyan-600)',
	cyan700: 'var(--epods--color-cyan-700)',
	cyan800: 'var(--epods--color-cyan-800)',
	cyan900: 'var(--epods--color-cyan-900)',
	cyanA100: 'var(--epods--color-cyan-a-100)',
	cyanA200: 'var(--epods--color-cyan-a-200)',
	cyanA400: 'var(--epods--color-cyan-a-400)',
	cyanA700: 'var(--epods--color-cyan-a-700)',

	//Teal
	teal50: 'var(--epods--color-teal-50)',
	teal100: 'var(--epods--color-teal-100)',
	teal200: 'var(--epods--color-teal-200)',
	teal300: 'var(--epods--color-teal-300)',
	teal400: 'var(--epods--color-teal-400)',
	teal500: 'var(--epods--color-teal-500)',
	teal600: 'var(--epods--color-teal-600)',
	teal700: 'var(--epods--color-teal-700)',
	teal800: 'var(--epods--color-teal-800)',
	teal900: 'var(--epods--color-teal-900)',
	tealA100: 'var(--epods--color-teal-a-100)',
	tealA200: 'var(--epods--color-teal-a-200)',
	tealA400: 'var(--epods--color-teal-a-400)',
	tealA700: 'var(--epods--color-teal-a-700)',

	//Green
	green50: 'var(--epods--color-green-50)',
	green100: 'var(--epods--color-green-100)',
	green200: 'var(--epods--color-green-200)',
	green300: 'var(--epods--color-green-300)',
	green400: 'var(--epods--color-green-400)',
	green500: 'var(--epods--color-green-500)',
	green600: 'var(--epods--color-green-600)',
	green700: 'var(--epods--color-green-700)',
	green800: 'var(--epods--color-green-800)',
	green900: 'var(--epods--color-green-900)',
	greenA100: 'var(--epods--color-green-a-100)',
	greenA200: 'var(--epods--color-green-a-200)',
	greenA400: 'var(--epods--color-green-a-400)',
	greenA700: 'var(--epods--color-green-a-700)',

	//Lime
	lime50: 'var(--epods--color-lime-50)',
	lime100: 'var(--epods--color-lime-100)',
	lime200: 'var(--epods--color-lime-200)',
	lime300: 'var(--epods--color-lime-300)',
	lime400: 'var(--epods--color-lime-400)',
	lime500: 'var(--epods--color-lime-500)',
	lime600: 'var(--epods--color-lime-600)',
	lime700: 'var(--epods--color-lime-700)',
	lime800: 'var(--epods--color-lime-800)',
	lime900: 'var(--epods--color-lime-900)',
	limeA100: 'var(--epods--color-lime-a-100)',
	limeA200: 'var(--epods--color-lime-a-200)',
	limeA400: 'var(--epods--color-lime-a-400)',
	limeA700: 'var(--epods--color-lime-a-700)',

	//Yellow
	yellow50: 'var(--epods--color-yellow-50)',
	yellow100: 'var(--epods--color-yellow-100)',
	yellow200: 'var(--epods--color-yellow-200)',
	yellow300: 'var(--epods--color-yellow-300)',
	yellow400: 'var(--epods--color-yellow-400)',
	yellow500: 'var(--epods--color-yellow-500)',
	yellow600: 'var(--epods--color-yellow-600)',
	yellow700: 'var(--epods--color-yellow-700)',
	yellow800: 'var(--epods--color-yellow-800)',
	yellow900: 'var(--epods--color-yellow-900)',
	yellowA100: 'var(--epods--color-yellow-a-100)',
	yellowA200: 'var(--epods--color-yellow-a-200)',
	yellowA400: 'var(--epods--color-yellow-a-400)',
	yellowA700: 'var(--epods--color-yellow-a-700)',

	//Orange
	orange50: 'var(--epods--color-orange-50)',
	orange100: 'var(--epods--color-orange-100)',
	orange200: 'var(--epods--color-orange-200)',
	orange300: 'var(--epods--color-orange-300)',
	orange400: 'var(--epods--color-orange-400)',
	orange500: 'var(--epods--color-orange-500)',
	orange600: 'var(--epods--color-orange-600)',
	orange700: 'var(--epods--color-orange-700)',
	orange800: 'var(--epods--color-orange-800)',
	orange900: 'var(--epods--color-orange-900)',
	orangeA100: 'var(--epods--color-orange-a-100)',
	orangeA200: 'var(--epods--color-orange-a-200)',
	orangeA400: 'var(--epods--color-orange-a-400)',
	orangeA700: 'var(--epods--color-orange-a-700)',

	//Brown
	brown50: 'var(--epods--color-brown-50)',
	brown100: 'var(--epods--color-brown-100)',
	brown200: 'var(--epods--color-brown-200)',
	brown300: 'var(--epods--color-brown-300)',
	brown400: 'var(--epods--color-brown-400)',
	brown500: 'var(--epods--color-brown-500)',
	brown600: 'var(--epods--color-brown-600)',
	brown700: 'var(--epods--color-brown-700)',
	brown800: 'var(--epods--color-brown-800)',
	brown900: 'var(--epods--color-brown-900)',

	//Corporate colors
	epodsRed: 'var(--epods--color-red-900)',
	epodsBlue: 'var(--epods--color-text-ds-blue)',
	focus: 'var(--epods--color-border-focus)',
	textPrimary: 'var(--epods--color-text-primary)',
	textSecondary: 'var(--epods--color-text-secondary)',

	// Rating Palette
	rating200: '#FFE3AC',
	rating400: '#FFC043',

	primaryFontFamily: 'var(--epods--font-base)',
};
